// ═══════════════════════════════════════════════════════════════════════════════
//  src/components/onboarding/pasos.js
//  EL ÍNDICE DEL DIAGNÓSTICO — UNA SOLA LISTA PARA TODO EL FLUJO
//
//  ── POR QUÉ EXISTE ──────────────────────────────────────────────────────────
//  Hasta hoy cada pantalla llevaba su número escrito a mano («Paso 3 de 7»).
//  Con siete pantallas repartidas en siete ficheros eso es una bomba de
//  relojería: el día que se parte una pregunta en dos —justo lo que pasó el
//  24-09-2026 con la intensidad y con los intentos previos— hay que acordarse
//  de corregir los otros seis rótulos, y el que se olvide deja al alumno
//  leyendo «Paso 5 de 7» en la sexta de nueve pantallas.
//
//  Aquí el número y el total salen de la posición en esta lista. Añadir o
//  quitar un paso es editar este arreglo, y los rótulos y la paginación se
//  recolocan solos.
//
//  ── POR QUÉ CADA PASO DECLARA SU CAMPO ──────────────────────────────────────
//  `campo` es el dato del payload que ese paso deja contestado. De ahí sale,
//  sin guardar ningún estado extra, qué pasos puede visitar el alumno: los que
//  ya contestó, más el siguiente. Un contador aparte de «hasta dónde llegué»
//  se desincroniza en cuanto alguien recarga a mitad del flujo.
// ═══════════════════════════════════════════════════════════════════════════════

export const PASOS = [
    { id: 1, campo: 'aspiration', nombre: 'Tu objetivo' },
    { id: 2, campo: 'trigger_event', nombre: 'Qué te trajo aquí' },
    { id: 3, campo: 'training_intensity', nombre: 'Tu intensidad' },
    { id: 4, campo: 'context_type', nombre: 'Dónde lo vas a usar' },
    { id: 5, campo: 'perceived_level', nombre: 'Cómo te ves' },
    { id: 6, campo: 'past_attempts', nombre: 'Intentos anteriores' },
    { id: 7, campo: 'technical_score', nombre: 'La calibración' },
    { id: 8, campo: 'feedback_style', nombre: 'Cómo quieres que te corrijan' },
    { id: 9, campo: null, nombre: 'Tu plan' },
];

export const TOTAL_PASOS = PASOS.length;

/** El rótulo de la chapa amarilla que encabeza cada pantalla. */
export function etiquetaDePaso(id) {
    return `Paso ${id} de ${TOTAL_PASOS}`;
}

/**
 * ¿Ese paso ya está contestado?
 *
 * La calibración tiene una excepción de producto: quien se declara «cero
 * absoluto» se la salta por diseño (Parte I §4 del documento maestro), así que
 * para él cuenta como resuelta — si no, se quedaría encerrado sin poder llegar
 * al último paso.
 */
export function pasoRespondido(id, payload, saltaCalibracion = false) {
    const paso = PASOS.find((p) => p.id === id);
    if (!paso || !paso.campo) return false;
    if (id === 7 && saltaCalibracion) return true;
    const valor = payload?.[paso.campo];
    return valor !== null && valor !== undefined && valor !== '';
}

/**
 * Los pasos que el alumno puede visitar: todos los que ya contestó, más el
 * primero que le queda pendiente. Nunca uno más adelante — saltarse una
 * pregunta dejaría el plan final hablando de datos que nadie dio.
 */
export function pasosAlcanzables(payload, saltaCalibracion = false) {
    const alcanzables = [];
    for (const paso of PASOS) {
        alcanzables.push(paso.id);
        if (!pasoRespondido(paso.id, payload, saltaCalibracion)) break;
    }
    return alcanzables;
}
